import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import Quiz from './components/quiz/Quiz';
import store from '../cart/services/store';

window.store = window.store || store;

document.addEventListener('DOMContentLoaded', () => {
  const quizElement = document.getElementById('react-quiz');
  let { quiz } = quizElement.dataset;
  quiz = JSON.parse(quiz);

  createRoot(
    quizElement,
  ).render(
    <Provider store={window.store}>
      <Quiz quiz={quiz} />
    </Provider>,
  );

  const StickyCategories = React.lazy(() => import('../homepage/components/sticky_categories/StickyCategories'));
  createRoot(
    document.getElementById('react-sticky-categories'),
  ).render(
    <Suspense fallback="">
      <Provider store={window.store}>
        <StickyCategories />
      </Provider>
    </Suspense>,
  );
});
